import { render, staticRenderFns } from "./InProgressAttach.vue?vue&type=template&id=72d603fd&"
import script from "./InProgressAttach.vue?vue&type=script&lang=js&"
export * from "./InProgressAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports